import React from 'react';

import CommonAlertsView from '../Components/CommonAlertsView/commonAlertsView';
import {SettingsMenuItemsIds} from '../../../../../enums/navigationMenuItemsIds';
import {getEnumValue, enumTypes} from '../../../../../utils/enumHelper';

import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';

require('./schedulerAlertsView.scss');

export default class SchedulerAlertsView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.settings.scheduler.view.');
  }

  componentDidMount() {
    this.props.actions.settingsPageActions.onSelectedMenuItemChanged(SettingsMenuItemsIds.NAV_ELEMENT_ALERTS_SCHEDULER);

    this.props.actions.load(getEnumValue(enumTypes.ALERT_TYPE)('PASSED_SCHEDULE'));
  }

  render() {
    return (
      <div className="late-start-view">
        <CommonAlertsView labels={this.labels}
                          actions={this.props.actions}
                          sData={this.props.sData}
                          isDirty={this.props.isDirty}
                          alertType={getEnumValue(enumTypes.ALERT_TYPE)('PASSED_SCHEDULE')}
        />
      </div>
    );
  }
}

